/* import __COLOCATED_TEMPLATE__ from './sms.hbs'; */
import TwoFactorEnrollSmsComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/sms';
export default class TwoFactorModalEnrollSmsComponent extends TwoFactorEnrollSmsComponent {
  // Override base component translation labels
  get invalidPhoneErrorTLabel() {
    return 'two_factor_modals.enroll.sms.errors.invalid_phone';
  }
  get unknownErrorTLabel() {
    return 'two_factor_modals.enroll.sms.errors.unknown';
  }
  constructor() {
    super(...arguments);
  }
}